import {groupRights} from "@services/current-rights.service";
import {guard} from "@/app/routes/guards/guard-factory";

export const guardCoachesEdit = guard(groupRights.Coaches)('edit')
export const guardCoachesWatch = guard(groupRights.Coaches)('watch')
export const guardCoachesCreate = guard(groupRights.Coaches)('create')

